import { api } from '../index';

const prefix = '/api/shopify/item/';

export function apiTransferItemClassToShopify(store_no, class_code) {
	return api.get(prefix + 'transferItemClassToShopify', { params: { store_no, class_code } });
}

// 사용 안 함.
export function apiGetUnregisteredItemClassList(store_no) {
	return api.get(prefix + 'getUnregisteredItemClassList', { params: { store_no } });
}

export function apiFileUploadTest(formData) {
	return api.post(prefix + 'fileUploadTest', formData);
}

export function apiGetExcelComparingAllProduct(store_no) {
	return api.get(prefix + 'getExcelComparingAllProduct', { params: { store_no } });
}

export function apiUpdateItemClassOnHandWithShopify(store_no, class_code) {
	return api.put(`${prefix}updateItemClassOnHandWithShopify/${store_no}/${class_code}`);
}
